<template>
  <div
    class="ws-state-multiple-layer-select"
    :class="[{'round':round},{active:menuActive},{'is-error':errors&&errors.length},{'is-disabled':_disabled}]"
    v-click-outside="$_onClickOutside"
  >
    <a
      href="#"
      @click.prevent="$_onOpenClick()"
      class="ws-state-multiple-layer-select__button"
      ref="wsStateRelationshipSelectButton"
    >
      <div
        v-if="value && value.length > 0"
        class="ws-state-multiple-layer-select__button-text"
      >{{_valueText}}</div>
      <div
        v-else
        class="ws-state-multiple-layer-select__placeholder"
      >{{placeholder}}</div>
      <v-icon class="icon">mdi-menu-down</v-icon>
    </a>
    <div
      v-if="menuActive"
      class="ws-state-multiple-layer-select__menu"
      :class="{top: _menuTopPosition}"
    >
      <!-- <div class="ws-state-multiple-layer-select__search-input-section">
        <div class="ws-state-multiple-layer-select__search-input">
          <v-icon class="icon">mdi-magnify</v-icon>
          <input
            ref="searchInput"
            type="text"
            v-model="searching"
          >
          <a
            @click.prevent="$_onInputClearClick()"
            class="search-input-clear-button"
          >
            <v-icon class="clear-icon">mdi-close-circle</v-icon>
          </a>
        </div>
      </div> -->
      <div class="ws-state-multiple-layer-select__select-section">
        <a
          @click="$_selectAll()"
          class="ws-state-multiple-layer-select__select-btn"
        >
          <v-icon class="select-icon">{{_allBtnIcon}}</v-icon> 所有
        </a>
      </div>
      <div
        v-if="loading"
        class="loading-section"
      >
        <v-progress-circular
          v-if="loading"
          size="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div
        v-else-if="_items.length"
        class="ws-state-multiple-layer-select__options"
        @scroll="$_getOptionsPosition()"
      >
        <div
          v-for="(firstLayer,firstLayerKey) in _items"
          :key="firstLayerKey"
        >
          <!-- First Layer -->
          <div
            class="ws-state-multiple-layer-select__options-title"
            @click="$_onFirstLayerClick(firstLayer)"
          >
            <v-icon class="title-icon">{{$_getFirstLayerStatus(firstLayer.menu,value)}}</v-icon>
            <p class="title-text">{{ firstLayer.title }}</p>
          </div>
          <div class="ws-state-multiple-layer-select__options-subtitle">
            <!-- Second Layer -->
            <div
              v-for="(secondLayer,secondLayerKey) in firstLayer.menu"
              :key="secondLayerKey"
              class="ws-state-multiple-layer-select__checkbox"
            >
              <label>
                <input
                  type="checkbox"
                  :checked="value && value.includes(secondLayer.value)"
                  @change="$_onChange($event,secondLayer.value)"
                >
                <v-icon
                  v-if="$_activeCheck(secondLayer)"
                  class="checkbox-icon"
                >mdi-checkbox-marked</v-icon>
                <v-icon
                  v-else
                  class="checkbox-icon"
                >mdi-checkbox-blank-outline</v-icon>
                <span class="checkbox-text">{{ secondLayer.text }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="no-result-text"
      >
        <p v-if="searching">找不到 ”{{searching}}” 相關搜尋結果</p>
        <p v-else>無選項</p>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  data: () => ({
    firstScroll: false,
    page: 1,
    totalPage: 1,
    searching: "",
    menuActive: false,
    modelDatas: [],
    fetchedItems: [],
    loading: false,
    searchTimeout: null,
    selectButttonPositionY: 0,
    window: {
      width: 0,
      height: 0,
    },
    scrollOptionsPosition: 0,
  }),
  methods: {
    $_getOptionsPosition() {
      this.$_itemsFetch("scroll");
    },
    $_activeCheck(item) {
      if (!this.value) {
        return;
      }
      return this.value.includes(item.value);
    },
    $_originValueToFetchedItems() {
      if (!this.originValue) {
        return;
      }
      if (this.multiple) {
        this.originValue.forEach((originValueItem) => {
          const text = this.getText
            ? this.getText(originValueItem)
            : originValueItem[this.textKey];
          this.fetchedItems.push({
            value: originValueItem[this.valueKey],
            text: text,
          });
        });
      } else {
        const text = this.getText
          ? this.getText(this.originValue)
          : this.originValue[this.textKey];
        this.fetchedItems.push({
          value: this.originValue[this.valueKey],
          text: text,
        });
      }
    },
    $_fetchPrepare() {
      this.loading = true;
      this.modelDatas = [];
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.$_itemsFetch();
      }, 500);
    },
    $_onInputClearClick() {
      this.searching = "";
      setTimeout(() => {
        if (!this.$refs.searchInput) return;
        this.$refs.searchInput.focus();
      }, 0);
    },
    $_onOptionClick(item) {
      if (this.multiple) {
        const _value = this.value ? JSON.parse(JSON.stringify(this.value)) : [];
        const itemIndex = _value.findIndex((e) => {
          return e == item.value;
        });
        if (itemIndex >= 0) {
          _value.splice(itemIndex, 1);
        } else {
          _value.push(item.value);
        }
        this.$emit("input", _value);
      } else {
        this.$emit("input", item.value);
        this.menuActive = false;
      }
    },
    $_onClickOutside() {
      this.menuActive = false;
    },
    $_onOpenClick() {
      this.$_getSelectButtonPositionY();
      this.menuActive = !this.menuActive;
      if (this.menuActive) {
        this.$_itemsFetch();
        this.$_handleResize();
        setTimeout(() => {
          if (!this.$refs.searchInput) return;
          this.$refs.searchInput.focus();
        }, 0);
      }
    },
    async $_itemsFetch(type) {
      if (type === "scroll") {
        this.loading = false;
        if (this.page >= this.totalPage && this.page !== 1) {
          return;
        }
      } else {
        this.loading = true;
      }
      let getUrl = this.getUrl
        ? `/${this.getUrl}`
        : this.parentState && this.parent
        ? `/${this.parent}/${this.parentState}/${this.modelName}`
        : `/${this.modelName}`;

      const params = {
        search: this.searching,
      };
      if (type === "scroll") {
        if (!this.firstScroll) {
          this.page = 1;
        } else {
          this.page++;
        }
        params.page = this.page;
      }
      if (this.excludeSelf) {
        const excludeIds = [this.modelId];
        params.excludes = excludeIds.join(",");
      }
      if (this.orderWay) {
        params.order_way = this.orderWay;
      }
      if (this.orderBy) {
        params.order_by = this.orderBy;
      }
      if (this.conditions) {
        this.conditions.forEach((condition) => {
          if (
            condition.type &&
            condition.type == "array" &&
            condition.value &&
            Array.isArray(condition.value)
          ) {
            params[condition.key] = condition.value.join();
          } else {
            params[condition.key] = condition.value;
          }
        });
      }
      try {
        const res = await this.$axios.get(getUrl, {
          params: params,
        });
        if (type === "scroll") {
          this.modelDatas = this.modelDatas.concat(res.data.data);
        } else {
          this.modelDatas = res.data.data;
        }
        if (type !== "scroll") {
          this.page = 1;
        }
        this.firstScroll = true;
        this.totalPage = res.data.meta.last_page;
        this.$_fetchedItemsSet();
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    $_fetchedItemsSet() {
      this._items.forEach((item) => {
        const tarIndex = this.fetchedItems.findIndex((e) => {
          return e.value == item.value && e.text == item.text;
        });
        if (tarIndex < 0) {
          this.fetchedItems.push(item);
        }
      });
    },
    valueReset() {
      this.$emit("input", null);
    },
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_getSelectButtonPositionY() {
      if (!this.$refs.wsStateRelationshipSelectButton) return;
      const selectButton = this.$refs.wsStateRelationshipSelectButton.getBoundingClientRect();
      this.selectButttonPositionY = selectButton.y;
    },
    $_onFirstLayerClick(firstLayer) {
      const layerStatus = this.$_getFirstLayerStatus(
        firstLayer.menu,
        this.value
      );
      const tarArr = [];
      firstLayer.menu.forEach((menuItem) => {
        tarArr.push(menuItem.value);
      });
      let newValue = JSON.parse(JSON.stringify(this.value));
      if (!newValue) {
        newValue = [];
      }
      if (
        layerStatus == "mdi-checkbox-blank-outline" ||
        layerStatus == "mdi-minus-box"
      ) {
        newValue = newValue.concat(tarArr);
        newValue = newValue.filter(
          (item, pos) => newValue.indexOf(item) === pos
        );
      } else if (layerStatus == "mdi-checkbox-marked") {
        newValue = newValue.filter((el) => {
          return !tarArr.includes(el);
        });
      }
      this.$emit("input", newValue);
      this.$emit("click");
    },
    $_getFirstLayerStatus(layerMenu) {
      const tarArr = [];
      layerMenu.forEach((menuItem) => {
        tarArr.push(menuItem.value);
      });
      if (this.value && tarArr.every((v) => this.value.includes(v))) {
        return "mdi-checkbox-marked";
      } else if (this.value && tarArr.some((r) => this.value.includes(r))) {
        return "mdi-minus-box";
      } else {
        return "mdi-checkbox-blank-outline";
      }
    },
    $_onChange($event, value) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if (!newValue) {
        newValue = [];
      }
      if ($event.target.checked) {
        if (!newValue.includes(value)) {
          newValue.push(value);
        }
      } else {
        newValue = newValue.filter((item) => item !== value);
      }
      this.$emit("input", newValue);
      this.$emit("click");
    },
    $_selectAll() {
      const allArr = [];
      const allValue = [];
      this._items.forEach((menu) => {
        menu.menu.forEach((item) => {
          allValue.push(item);
        });
      });
      if (!this.value || this.value.length < allValue.length) {
        this._items.forEach((firstLayer) => {
          firstLayer.menu.forEach((secondLayer) => {
            allArr.push(secondLayer.value);
          });
        });
      }
      this.$emit("input", allArr);
      this.$emit("click");
    },
  },
  computed: {
    _allBtnIcon() {
      const allValue = [];
      this._items.forEach((menu) => {
        menu.menu.forEach((item) => {
          allValue.push(item);
        });
      });
      if (
        this.value &&
        this.value.length < allValue.length &&
        this.value.length > 0
      ) {
        return "mdi-minus-box";
      } else if (!this.value || this.value.length === 0) {
        return "mdi-checkbox-blank-outline";
      } else {
        return "mdi-checkbox-marked";
      }
    },
    _disabled() {
      if (this.parent && !this.parentState) {
        return true;
      } else if (
        this.requiredField &&
        (!this.requiredFieldState || this.requiredFieldState.length == 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
    _valueText() {
      if (!this.value) return;
      const allValue = [];
      this._items.forEach((menu) => {
        menu.menu.forEach((item) => {
          allValue.push(item);
        });
      });
      if (this.value.length === allValue.length) {
        return "所有領域";
      } else if (this.value.length == 0) {
        return this.placeholder;
      } else {
        const selectValue = [];
        allValue.forEach((value) => {
          if (this.value.indexOf(value.value) > -1) {
            selectValue.push(value);
          }
        });
        const selectValueText = selectValue.map((select) => select.text);
        return selectValueText.join("、");
      }
    },
    _items() {
      let menu = JSON.parse(JSON.stringify(this.modelDatas));
      let menuData = [];
      menu.forEach((menuItem) => {
        let item = {};
        item.title = menuItem.name;
        item.menu = menuItem.system_subclasses;
        menuData.push(item);
      });
      menuData.forEach((menuItem, menuIndex) => {
        menuItem.menu.forEach((systemItem, systemIndex) => {
          let systemData = {};
          systemData.text = systemItem.name;
          systemData.value = systemItem.id;
          menuData[menuIndex].menu[systemIndex] = systemData;
        });
      });
      return menuData;
    },
    _menuTopPosition() {
      if (this.window.height - this.selectButttonPositionY < 400) {
        return true;
      } else {
        return false;
      }
    },
  },
  props: {
    modelId: {
      type: [Number, String],
      default: null,
    },
    excludeSelf: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: null,
    },
    note: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    getText: {
      type: Function,
      default: null,
    },
    conditions: {
      type: Array,
      default: null,
    },
    requiredField: {
      default: null,
    },
    requiredFieldState: {
      default: null,
    },
    parentState: {
      default: null,
    },
    parent: {
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    round: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "select",
    },
    originValue: {},
    value: {},
    textKey: {
      type: String,
      default: "name",
    },
    valueKey: {
      type: String,
      default: "id",
    },
    orderWay: {
      type: String,
      default: "",
    },
    orderBy: {
      type: String,
      default: "",
    },
    getUrl: {
      type: String,
      default: "",
    },
  },
  watch: {
    searching: {
      handler() {
        this.$_fetchPrepare();
      },
    },
    parentState: {
      handler() {
        this.valueReset();
      },
    },
  },
  directives: {
    ClickOutside,
  },
  mounted() {
    this.$_originValueToFetchedItems();
    this.$_handleResize();
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-state-multiple-layer-select.scss";
</style>